import { render, staticRenderFns } from "./LSV.vue?vue&type=template&id=8a1dcccc&scoped=true"
import script from "./LSV.vue?vue&type=script&lang=js"
export * from "./LSV.vue?vue&type=script&lang=js"
import style0 from "./LSV.vue?vue&type=style&index=0&id=8a1dcccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1dcccc",
  null
  
)

export default component.exports